const language = {
  english:{
    search:"Search",
    gptSearchPlaceholder:"What would you like to watch today?"
  },
  hindi:{
    search:"खोज",
    gptSearchPlaceholder:"आज आप क्या देखना चाहेंगे?"
  },
};

export default language;